<template>
    <div class="container-bary">
        <v-chart :options="option"  ref="ff" autoresize/>
       
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'zrender/lib/svg/svg'
import "echarts/lib/component/graphic";



export default {
  name: 'scatter',
  props: {  
     ids:String
  },
  data () {  
    return {     
      
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
       this.ff=this.$refs.ff,

    this.option = {
				//backgroundColor: "#0D1B5B",
				// X轴的数据
				xAxis: {
				//	max:50,
					name:"增长率",
						// 线的样式
					splitLine: {
						show: true,
						lineStyle: {
							color: '#454A5C',
							type: 'solid',
						},
						minInterval: 1
					},
					// X轴字体样式
					axisLine: {
						show: false,
                        
						lineStyle: {
							color: '#ffffff',
							type: 'solid',
								opacity:0.5
						},
					
					},
					axisLabel :
					 {
					     formatter : function (value)
					     {
					         let valueTxt = '';
					         if (value.length > 3) {
					             valueTxt = value.substring(0, 4) ;
					         }
					         else {
					             valueTxt = value;
					         }
					         return valueTxt+"%" ;
					     }
					 }
				},
				// 圆点的颜色
				color: ['#377DFF', '#377DFF'],
				// Y轴的数据
				yAxis: {
					//max:50,

					name:"流失率",
					// 线的样式
					splitLine: {
						show: true,
						lineStyle: {
							color: '#454A5C',
							type: 'solid',
						},
						minInterval: 1,
						opacity:0.5
					},
					// X轴字体样式
					axisLine: {
						show: false,
						lineStyle: {
							color: '#fff',
							type: 'solid',
						},
						
					},
					axisLabel :
					 {
					     formatter : function (value)
					     {
					         let valueTxt = '';
					         if (value.length > 3) {
					             valueTxt = value.substring(0, 4) ;
					         }
					         else {
					             valueTxt = value;
					         }
					         return valueTxt+"%" ;
					     }
					 }
				},
				tooltip :{
					formatter:function(params){
						var result=""
						params.forEach(function(item){
							var firstparam=item.value[0]
						var endparam=item.value[1];
						
						result=item.value[2]+"<br>增长率:"+firstparam+"%<br>流失率:"+endparam+"%";
						})
						return result //"<span style='display:inline-block;margin-right:5px;border-radius:50%;width:80px;height:80px;background-color:#377DFF;'></span>"
						
					},
					textStyle:{
						fontSize:18
					},
				 trigger: "axis",
				 axisPointer: {
					type:"none",
				 }
				},
				series: [{
					symbolSize: 18,
					data: [
			          ],
					type: 'scatter',
					  emphasis: {
                                itemStyle: {
                                    borderColor: '#377DFF', 
                                    borderWidth: 22, 
                                    areaStyle: {color: '#377DFF'},
									shadowColor:'#377DFF',
									opacity:1
                                }
                            },
				}
				],
				graphic: [
					{
						type: 'group',
						top: "17%",
						left: "10%",
						children: [{
								type: 'rect',
								left: 'center',
								top: 'center',
								shape: {
									width: 91,
										height: 65
								},
								style: {
									fill: '#3D2D14'
								}
							},
							{
								type: 'text',
								left: 'center',
								top: 'center',
								z: 0,
								style: {
									fill: '#000000',
									text: '低增长\n高流失',
									font: '25px PingFangSC-Semibold'
								}
							}
						]
					},
					{
							type: 'group',
							top: "17%",
							right: "10%",
							children: [{
									type: 'rect',
									left: 'center',
									top: 'center',
									shape: {
										width: 91,
										height: 65
									},
									style: {
										fill: '#490C1A'
									}
								},
								{
									type: 'text',
									left: 'center',
									top: 'center',
									z: 0,
									style: {
										fill: '#000000',
										text: '高增长\n高流失',
										font: '25px PingFangSC-Semibold'
									}
								}
							]
						},
					{
							type: 'group',
							bottom: "17%",
							right: "10%",
							children: [{
									type: 'rect',
									left: 'center',
									top: 'center',
									shape: {
										width: 91,
										height: 65
									},
									style: {
										fill: '#05395A'
									}
								},
								{
									type: 'text',
									left: 'center',
									top: 'center',
									z: 0,
									style: {
										fill: '#000000',
										text: '高增长\n低流失',
										font: '25px PingFangSC-Semibold'
									}
								}
							]
						},
					{
							type: 'group',
							bottom: "17%",
							left: "10%",
							children: [{
									type: 'rect',
									left: 'center',
									top: 'center',
									shape: {
										width: 91,
										height: 65
									},
									style: {
										fill: '#043C25'
									}
								},
								{
									type: 'text',
									left: 'center',
									top: 'center',
									z: 0,
									style: {
										fill: '#000000',
										text: '低增长\n低流失',
										font: '25px PingFangSC-Semibold'
									}
								}
							]
						},
				]

			};
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-bary2{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>